import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [authOpen, setAuthOpen] = useState(false);
  const [authMode, setAuthMode] = useState("signup");

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const openAuth = useCallback((mode = "signup") => {
    setAuthMode(mode);
    setAuthOpen(true);
  }, []);

  const requireUser = useCallback(() => {
    if (user) return true;
    openAuth("signup");
    return false;
  }, [user, openAuth]);

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, authOpen, setAuthOpen, authMode, setAuthMode, openAuth, requireUser, logout }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
